/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { HiveAccessToken } from "./data-contracts";

/**
 * No description
 * @tags hive, critical, internal
 * @name GenerateHiveAccessToken
 * @summary Returns a token to authenticate with Hive.
 * @request POST:/internal/hive/token
 * @secure
 */

// @ts-ignore
export const generateHiveAccessToken: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {};
  RequestQuery: {};
  RequestBody: {
    /** @deprecated */
    spaces?: string[];
    contentIds?: string[];
  };
  RequestHeaders: {};
  ResponseBody: HiveAccessToken;
  ResponseStatusCode: 200;
} = {
  route: "/internal/hive/token",
  method: "post",
  streaming: false,
  tags: ["hive", "critical", "internal"],
  criticalityLevel: "high",
  deprecated: false,
};
